export interface WebRtcSignaling {

    kind: WebRtcSignalingKind;

    clientId: string;

    content: WebRtcSignalingContent;

}


export interface WebRtcSignalingContent {

    type?: string;

    sdp?: string;

    candidate?: string;

    sdpMid?: string | null;

    sdpMLineIndex?: number | null;

}


export enum WebRtcSignalingType {

    offer,

    answer

}


export enum WebRtcSignalingKind {
    unknown = 0,
    answer = 1,
    offer = 2,
    ice = 3
}
